<template>
  <div class="maintenance">
    <div class="leftMain">
      <maintenanceMain @currentac="currentac" @changeListArr="changeListArr1" @gqARR="gqARR1" @currentCheck="currentCheck1" :message="message" @changemessage="changemessage1" />
    </div>
    <div class="rightList">
      <div class="btnList" v-if="currentacNum == -1">
        <div class="listItem" v-for="(v, i) in btnlist" :key="i" @click="btnFunc(v,i)">{{ v }}</div>
      </div>
      <div class="cancleBtn" v-if="currentacNum == -1" @click="changeStatus(-1)">取消选择</div>
      <div class="cancleBtn" v-else-if="currentacNum == 4" @click="changeStatus(4)">取消估清</div>
      <div class="cancleBtn" v-else-if="currentacNum == 3" @click="changeStatus(3)">取消锁菜</div>
      <div class="cancleBtn" v-else-if="currentacNum == 0" @click="changeStatus(0)">取消推荐菜</div>
      <div class="cancleBtn" v-else-if="currentacNum == 1" @click="changeStatus(1)">取消欢迎菜</div>
      <div class="cancleBtn" v-else-if="currentacNum == 2" @click="changeStatus(2)">取消热卖菜</div>
    </div>
    <el-dialog title="沽清列表" :visible.sync="listDialog" width="899px" center>
      <div class="listmain">
        <!-- <div class="listSearch"></div> -->
        <div class="tableBottom">
          <div class="checkStyle">
            <!--   <el-date-picker v-model="timevalue1" type="date" placeholder="选择日期">
            </el-date-picker> -->

            <el-date-picker @change="gqchange" value-format="yyyy-MM-dd" v-model="timevalue1" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
            </el-date-picker>
          </div>

          <div>
            <el-input placeholder="输入菜品编码、助记码、条形码查询" @change="inputchange" v-model="inputSearch" clearable style="width: 300px; height: 50px; line-height: 50px">
            </el-input>
          </div>
        </div>
        <div class="listmaintable">
          <el-table ref="multipleTable" @selection-change="selectTableData" :data="tableData" tooltip-effect="dark" style="width: 100%" max-height="350px" >
            <el-table-column type="selection"> </el-table-column>
            <el-table-column label="营业日期">
              <template slot-scope="scope">{{ scope.row.buinessDate }}</template>
            </el-table-column>
            <el-table-column prop="foodName" label="菜品名称"> </el-table-column>
            <el-table-column prop="surplusCount" label="预售数量" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="count" label="沽清数量" show-overflow-tooltip>
            </el-table-column>
            <el-table-column label="已售数量" show-overflow-tooltip>
              <template slot-scope="scope">{{ scope.row.count -  scope.row.surplusCount }}</template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <span slot="footer" style="width: 100%; display: flex; justify-content: flex-end" class="dialog-footer">
        <div class="">
          <el-button style="
              background: #0099ff;
              color: #fff;
              width: 120px;
              height: 60px;
              border-radius: 38px;
            " @click="listDialog = false">退 出</el-button>
          <el-button style="
              background: #0099ff;
              color: #fff;
              width: 120px;
              height: 60px;
              border-radius: 38px;
            " @click="delgqList">删 除</el-button>
          <el-button style="" class="" type="primary" @click="gqysClick">沽清延时</el-button>
        </div>
      </span>
    </el-dialog>
    <el-dialog title="估清延时" :visible.sync="listdelay" width="530px" center>
      <div>
        <el-radio-group fill="#0099ff" v-model="listdelayradio1">
          <el-radio-button label="不固定时段"></el-radio-button>
          <el-radio-button label="固定时段"></el-radio-button>
        </el-radio-group>
      </div>
      <div v-if="listdelayradio1 == '不固定时段'" class="" style="
          width: 100%;
          margin: 50px auto 0;
          display: flex;
          justify-content: center;
          align-items: center;
          flex-direction: column;
        ">
        <span style="margin-bottom: 20px; color: #666; font-size: 20px">营业时间</span>
        <el-date-picker v-model="value1" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
        </el-date-picker>
        <!-- <el-date-picker  value-format="yyyy-MM-dd" v-model="value1" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
            </el-date-picker> -->
      </div>
      <div v-if="listdelayradio1 == '固定时段'">
        <div class="delayTime">
          <div class="delayItem" v-for="(v, i) in delayTimeList" :key="i" @click="currentDelayclick(i)">
            <div> {{ v.time }} </div>
            <img :src=" currentDelay==i ? v.selectImgUrl : v.imgurl " width="38px" height="38px" alt="" />
          </div>
        </div>
      </div>
      <div></div>
      <span slot="footer" class="dialog-footer">
        <el-button style="
            background: #0099ff;
            color: #fff;
            height: 60px;
            border-radius: 38px;
          " @click="listdelay = false">取消估清</el-button>
        <el-button style="margin-left: 20px" type="primary" @click="delayYS">估清延时</el-button>
      </span>
    </el-dialog>
    <el-dialog title="估清" :visible.sync="ValuationDialog" width="460px" center>
      <div class="addFoodMain">
        估清
        <el-input v-model="ValuationgNum" style="width: 200px; margin: 0 15px" placeholder="请输入内容"></el-input>
        份
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button style="
            background: #0099ff;
            color: #fff;
            width: 120px;
            height: 60px;
            border-radius: 38px;
          " @click="ValuationDialog = false">取 消</el-button>
        <el-button style="" type="primary" @click="ValuationClick">确 定</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
import maintenanceMain from "./components/maintenanceMain.vue";
import qs from 'qs'
import axios from 'axios'
export default {
  components: {
    maintenanceMain,
  },
  data() {
    return {
      ValuationDialog: false,
      ValuationgNum: '',
      inputSearch: '',
      timevalue1: '',
      value1: '',
      currentDelay: 0,
      currentacNum: -1,
      delayTimeList: [
        { time: "延时一天", imgurl: require("../../assets/imgs/noselect.png"), selectImgUrl: require("../../assets/imgs/select.png") },
        { time: "延时一月", imgurl: require("../../assets/imgs/noselect.png"), selectImgUrl: require("../../assets/imgs/select.png") },
        { time: "延时半年", imgurl: require("../../assets/imgs/noselect.png"), selectImgUrl: require("../../assets/imgs/select.png") },
        { time: "延时一年", imgurl: require("../../assets/imgs/noselect.png"), selectImgUrl: require("../../assets/imgs/select.png") },
      ],
      listdelayradio1: "不固定时段",
      tableData: [

      ],
      listDialog: false,
      listdelay: false,
      message: 0,
      btnlist: [
        "菜品沽清",
        "沽清列表",
        "设推荐菜",
        "设欢迎菜",
        "设热卖菜",
        "锁菜",
      ],
      changeListArr: [],
      currentCheck: '',
      changeType: 1,
      changeValue: true,
      delList: [],
      gqCLList: [],
      gqdel: [],
    };
  },
  created() {
    this.getNowFormatDate()
  },
  methods: {
    // 当天时间
    getNowFormatDate() {
      var date = new Date();
      var seperator1 = "-";
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var strDate = date.getDate();
      if (month >= 1 && month <= 9) {
        month = "0" + month;
      }
      if (strDate >= 0 && strDate <= 9) {
        strDate = "0" + strDate;
      }
      this.timevalue1 = year + seperator1 + month + seperator1 + strDate;
      this.value1 = year + seperator1 + month + seperator1 + strDate;
      this.timevalue1 = [this.timevalue1, this.timevalue1]
      this.value1 = [this.value1, this.value1]
    },
    // 选中的id
    selectTableData(v) {
      let arr = []
      let arr1 = []
      v.forEach(val => {
        arr.push(val.id)
        arr1.push(val.dishesId)
      })
      this.delList = arr
      this.gqCLList = arr1
    },
    gqysClick() {
      if (this.delList.length == 0) {
        this.$notify.error({
          title: '请选择一条数据'
        });
        return
      }
      this.listdelay = true
      console.log(this.value1);
    },
    delayYS() {

      let str = 1;
      if (this.listdelayradio1 == '不固定时段') {
        str = 1
      } else {
        str = 2
      }
      if (str == 1) {
        let url = this.api.delayedEstimate
        let methods = 'put'
        let data = {
          foodDishesIds: this.gqCLList,
          flag: str,
          timeBegin: this.value1[0],
          timeEnd: this.value1[1],
        }
        this.$axios({ url, methods, data }).then(res => {
          if (res.data.status == 0) {
            this.$notify.success({
              title: res.data.message
            });
            this.listdelay = false

          } else {
            this.$notify.error({
              title: res.data.message
            });
          }
        })

      } else {
        console.log(this.currentDelay);
        let url = this.api.delayedEstimate
        let methods = 'put'
        let data = {
          foodDishesIds: this.gqCLList,
          flag: str,
          delayedTpye: this.currentDelay + 1,
        }
        this.$axios({ url, methods, data }).then(res => {
          if (res.data.status == 0) {
            this.$notify.success({
              title: res.data.message
            });
            this.listdelay = false

          } else {
            this.$notify.error({
              title: res.data.message
            });
          }
        })
      }

    },
    delgqList() {
      if(this.delList.length == 0){
        this.$notify.error({
          title: '请选择一条数据'
        });
        return
      }
      let data = {
        ids: this.delList,
      }
      axios.delete(this.api.deleteEstimate, { data: data }).then(res => {
        console.log(res);
        if (res.data.status == 0) {
          this.$notify.success({
            title: res.data.message
          });
          this.listDialog = false
        }
      })

    },
    inputchange() {
      this.estimateList()
    },
    gqchange() {
      this.estimateList()
      console.log(this.timevalue1);
    },
    estimateList() {
      let url = this.api.estimateList
      let methods = 'post'
      let data = {
        begin: this.timevalue1[0],
        end: this.timevalue1[1],
        serchCode: this.inputSearch,
      }
      this.$axios({ url, methods, data }).then(res => {
        if (res.data.status == 0) {
          this.tableData = res.data.data
          this.$notify.success({
            title: res.data.message
          });
        } else {
          this.$notify.error({
            title: res.data.message
          });
        }
      })

    },
    //沽清
    ValuationClick() {
      if (!this.ValuationgNum) {
        this.$notify.error({
          title: '沽清数填写错误'
        });
      }
      let url = this.api.setEstimate
      let methods = 'post'
      let data = {
        foodDishesIds: this.changeListArr,
        count: this.ValuationgNum,
      }
      this.$axios({ url, methods, data }).then(res => {
        if (res.data.status == 0) {
          this.$notify.success({
            title: res.data.message
          });
          this.$router.go(0);
        } else {
          this.$notify.error({
            title: res.data.message
          });
        }
      })

    },
    deleteEstimate() {
      console.log(this.gqdel);
      let data = {
        ids: this.gqdel,
      }

      axios.delete(this.api.deleteEstimate, { data: data }).then(res => {
        console.log(res);
        if (res.data.status == 0) {
          this.$notify.success({
            title: res.data.message
          });
          this.$router.go(0)
        }
      })

    },
    changeStatus(v) {
      console.log(v);
      if (v == 0) {
        this.changeType = 1
        this.changeValue = false
        this.changeData()
      } else if (v == 1) {
        this.changeType = 2
        this.changeValue = false
        this.changeData()

      } else if (v == 2) {
        this.changeType = 3
        this.changeValue = false
        this.changeData()

      } else if (v == 3) {
        this.changeType = 4
        this.changeValue = false
        this.changeData()

      } else if (v == 4) {
        this.deleteEstimate()

      } else if (v == '-1') {
        this.message = 1
      }
    },
    changeData() {
      let url = this.api.changeDishesStatus
      let methods = 'put'
      let data = {
        foodDishesIds: this.changeListArr,
        dishesType: this.currentCheck,
        type: this.changeType,
        value: this.changeValue,
      }
      this.$axios({ url, methods, data }).then(res => {
        if (res.data.status == 0) {
          this.$notify.success({
            title: res.data.message
          });
          this.$router.go(0);
        } else {
          this.$notify.success({
            title: res.data.message
          });
        }
      })

    },
    btnFunc(v, i) {
      if (v == '菜品沽清') {
        this.ValuationDialog = true
      } else if (v == '沽清列表') {
        this.listDialog = true
        this.estimateList()
      } else if (v == '设推荐菜') {
        this.changeType = 1
        this.changeValue = true
        this.changeData()
      } else if (v == '设欢迎菜') {
        this.changeType = 2
        this.changeValue = true
        this.changeData()
      } else if (v == '设热卖菜') {
        this.changeType = 3
        this.changeValue = true
        this.changeData()
      } else if (v == '锁菜') {
        this.changeType = 4
        this.changeValue = true
        this.changeData()
      }
    },
    changeListArr1(v) {
      this.changeListArr = v
    },
    gqARR1(v) {
      this.gqdel = v

    },
    currentCheck1(v) {
      this.currentCheck = v + 1
    },
    changemessage1(v) {
      this.message = v

    },
    currentac(v) {
      this.currentacNum = v
    },
    // 延时选择
    currentDelayclick(i) {
      this.currentDelay = i
      console.log(this.currentDelay);
    },
    handleSelectionChange() {
      console.log(1);
    }
  }
};
</script>

<style lang="scss" scoped>
.maintenance {
  width: 100%;
  height: 100%;
  display: flex;

  justify-content: space-between;
  .leftMain {
    background: #fff;
    border-radius: 20px;
    max-height: calc(100vh - 150px);
    height: 100%;
    max-width: calc(100vw - 250px);
    min-width: calc(100vw - 250px);
  }
  .rightList {
    width: 220px;
    background: #fff;
    border-radius: 20px;
    min-height: calc(100vh - 150px);
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    .btnList {
      display: flex;
      flex-direction: column;
      align-items: center;
      .listItem {
        width: 160px;
        height: 60px;
        background: #0099ff;
        box-shadow: 0px 2px 10px 0px rgba(0, 153, 255, 0.3);
        border-radius: 38px;
        text-align: center;
        line-height: 60px;
        color: #fff;
        cursor: pointer;
        margin-top: 30px;
      }
      .listItem:nth-child(3) {
        background: linear-gradient(225deg, #ffbe34 0%, #fe812f 100%);
        box-shadow: 0px 2px 10px 0px rgba(254, 137, 47, 0.3);
      }
      .listItem:nth-child(4) {
        background: linear-gradient(225deg, #ffbe34 0%, #fe812f 100%);
        box-shadow: 0px 2px 10px 0px rgba(254, 137, 47, 0.3);
      }
      .listItem:nth-child(5) {
        background: linear-gradient(225deg, #ffbe34 0%, #fe812f 100%);
        box-shadow: 0px 2px 10px 0px rgba(254, 137, 47, 0.3);
      }
    }
    .cancleBtn {
      width: 160px;
      height: 60px;
      background: #0099ff;
      box-shadow: 0px 2px 10px 0px rgba(0, 153, 255, 0.3);
      border-radius: 38px;
      text-align: center;
      line-height: 60px;
      color: #fff;
      cursor: pointer;
      margin-bottom: 20px;
      position: absolute;
      bottom: 0;
    }
  }
  .listmain {
    width: 100%;
    .tableBottom {
      display: flex;
      align-items: center;
      justify-content: center;
      .checkStyle {
        display: flex;
        margin-right: 30px;
      }
    }
  }
  .delayTime {
    margin-top: 30px;
    display: flex;
    justify-content: space-around;
    .delayItem {
      width: 24%;
      height: 114px;
      display: flex;
      cursor: pointer;
      background: #eeeeee;
      border-radius: 6px;
      flex-direction: column;
      align-items: flex-end;
      font-size: 24px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #666666;
      justify-content: center;
      div {
        display: flex;
        justify-content: center;
        margin-bottom: 15px;
        width: 100%;
      }
      img {
        display: flex;
        justify-content: flex-end;
        margin-right: 10px;
      }
    }
  }
  .addFoodMain {
    height: 66px;
    display: flex;
    width: 100%;
    justify-content: center;
    margin-top: 36px;
    align-items: center;
    font-size: 24px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #666666;

    /deep/.el-input__inner {
      font-size: 24px;
      border: none;
      width: 200px !important;
      padding: 0;
      background: #eee;
      text-align: center;
      height: 66px;
    }
  }
}
</style>
<style lang="scss" scoped>
/deep/.el-dialog {
  display: flex;
  flex-direction: column;
  align-items: center;
  border-radius: 20px;
  margin-top: 9vh !important;
}
/deep/.el-dialog__header {
  margin-top: 50px;
  background: #fff;
}
/deep/.el-dialog__title {
  color: #0099ff;
  font-size: 28px;
}
/deep/.el-dialog__body {
  width: 100%;
}

/deep/.el-radio-button__inner {
  width: 240px !important;
  height: 66px;
  line-height: 43px;
  font-size: 24px;
  color: #666;
}
/deep/.dialog-footer {
  margin-bottom: 20px;
  .el-button {
    width: 160px;
    height: 60px;
    background: #0099ff;
    background: linear-gradient(225deg, #ffbe34 0%, #fe812f 100%);
    box-shadow: 0px 2px 10px 0px rgba(254, 137, 47, 0.3);
    border-radius: 38px;
    text-align: center;
    color: #fff;
    cursor: pointer;
    margin-top: 30px;
    border: none;
    font-size: 24px;
  }
}
</style>
